   @if (!isExternoRds) {
<div class="sidebar" [class.collapsed]="isCollapsedSidebar">

  <div class="header d-flex align-items-center py-4"
       [ngClass]="{'justify-content-center': isCollapsedSidebar, 'justify-content-between': !isCollapsedSidebar}">

    <p class="m-0" [style.width]="isCollapsedSidebar ? '0px' : 'auto'">
      {{ !isCollapsedSidebar ? 'Data Maintenance' : 'DM' }}
    </p>

    <button class="btn-icon-collapse cursor-pointer" (click)="toggleSidebar()" aria-label="Expandir o colapsar menú">
      <span class="material-symbols-outlined">menu</span>
    </button>
  </div>

  <div class="body">
    <ul>


      <div class="section-wrapper py-2 border-bottom-1">
        @for (item of menuItems; track item.title) {
          @if (visibleItem(item)) {

            <li class="item-menu d-flex align-items-center cursor-pointer position-relative"
                [class.item-active]="hasActiveSubItem(item) || isRouteActive(getRoutePath(item))"
                (click)="routeMenuSelected(item, $event)"
                [attr.efxTooltip]="isCollapsedSidebar ? item.title : null"
                efxTooltipPlacement="right">

              <div class="icon-container d-flex align-items-center justify-content-center">
                 @if(item.icon) { <img [src]="item.icon" [alt]="item.title"> }
              </div>

              <div class="label-menu flex-grow-1">{{ item.title }}</div>

              @if (hasSubItems(item)) {
                <span class="material-symbols-outlined arrow-icon" style="font-size: 18px;">
                  {{ isMenuExpanded(item) ? 'expand_less' : 'expand_more' }}
                </span>
              }
            </li>

            @if (hasSubItems(item)) {
              <div class="submenu-container" [class.expanded]="isMenuExpanded(item) && !isCollapsedSidebar">
                <ul class="submenu-list">
                  @for (sub of item.subItems; track sub.title) {
                    @if (visibleItem(sub)) {
                      <li class="item-menu submenu-item d-flex align-items-center"
                          [class.item-active]="isRouteActive(getRoutePath(sub))"
                          (click)="onSubItemClick(sub, $event)">
                          <div class="submenu-item-inner flex-grow-1 d-flex align-items-center">
                            <div class="label-menu">{{ sub.title }}</div>
                          </div>
                      </li>
                    }
                  }
                </ul>
              </div>
            }
          }
        }
      </div>

      <div class="section-wrapper pt-2">
        <li class="item-menu d-flex align-items-center cursor-pointer"
            (click)="logoutSessionGoToHome()"
            [attr.efxTooltip]="isCollapsedSidebar ? 'Salir' : null"
            efxTooltipPlacement="right">
          <div class="icon-container d-flex align-items-center justify-content-center">
            <span class="material-symbols-outlined">logout</span>
          </div>
          <div class="label-menu">Salir</div>
        </li>
      </div>

    </ul>
  </div>
</div>
   }
